import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import cn from 'classnames';
import './FeaturedCuratorGroup.scss';

import { getPreviewImageForGroup, getCoverImageForGroup, getLinkToShopForCuratorGroup } from '../../Helpers/shop_helpers';
import { getUserId } from '../../Helpers/user_helpers';

const FeaturedCuratorGroup = props => {
  const { user, favorite, group } = props;
  const { id, curated_by, isSearchable } = group;

  const isCuratedByYou = curated_by?.id === getUserId(user);
  const isCuratedByShopMy = !curated_by;
  const isHiddenButVisibleToAdmins = !isSearchable && isCuratedByShopMy;

  // Get data from the group
  const previewImage = getPreviewImageForGroup(group);
  const coverImage = getCoverImageForGroup(group);
  const num_curators = favorite || group.preview_group_users?.length ? group.num_curators : group.group_users?.length;

  // Curated By Message
  let curatedByMessage;
  if (group.industry) {
    curatedByMessage = `${group.industry.name}, curated by`;
  } else if (group.department) {
    curatedByMessage = `${group.department.name}, curated by`;
  } else if (group.category) {
    curatedByMessage = `${group.category.name}, curated by`;
  } else {
    curatedByMessage = 'Curated by';
  }

  const viewGroup = () => props.selectGroup(group);

  // Actions
  let badges = [];

  // Badges - Focus
  const mainFocus = group?.category?.name || group?.department?.name || group?.industry?.name || 'All Categories';
  if (mainFocus) badges.push(mainFocus);

  // Badges - Curated By
  if (isCuratedByYou) badges.push('By You');
  else if (isCuratedByShopMy) badges.push('By ShopMy');
  else if (group.curated_by) badges.push(`By ${group.curated_by.name}`);

  // UI Classes
  const additionalClasses = {
    'is-loading': props.isLoading
  };

  return (
    <div className={cn('featured-curator-group-container', additionalClasses)} key={id}>
      {!!coverImage && (
        <div className={cn('background-image', additionalClasses)}>
          <img src={coverImage} alt={group.title} />
          {isHiddenButVisibleToAdmins && <div className='hidden-except-admins-overlay'>Hidden</div>}
        </div>
      )}
      <div className={cn('content-container', additionalClasses)}>
        <div onClick={viewGroup} className={cn('content', { clickable: props.selectGroup }, additionalClasses)}>
          <div className={cn('image-container', additionalClasses)}>
            <img src={previewImage} alt={group.title} />
          </div>
          <div className={cn('data', additionalClasses)}>
            <div className='curated-by'>{curatedByMessage}</div>
            <div className='title'>{group.title || 'No Title'}</div>
            <div className='metadata'>{`${num_curators} ${pluralize('curator', num_curators)}`}</div>
          </div>
        </div>
        <div className='actions'>
          <Link to={getLinkToShopForCuratorGroup(group, user)} className='action'>
            Shop Products
          </Link>
        </div>
      </div>
    </div>
  );
};

FeaturedCuratorGroup.propTypes = {
  user: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
  favorite: PropTypes.object, // If it's a Favorite, this is the outer object
  isLoading: PropTypes.bool,
  selectGroup: PropTypes.func
};

export default FeaturedCuratorGroup;
